// extracted by mini-css-extract-plugin
export default {"root":"mqeLIiAo","body":"LEuuEclC","content":"z0mK3PBM","section":"KaSbXWDX","insightsStack":"PCJeCvkX","bottomBar":"SyLjN1Ua"};